const colors = {
  mainBackground: '#ffffff',
  errorText: '#FF6341',
  textPrimaryGray: '#b9b1b1',
  textPrimaryDark: '#0f0f0f',
  buttonPrimary: '#4791db',
  radioButton: '#d9d9d9',
  buttonDisabled: '#dedddd',
  defaultLight: '#e0e0e0',
  lightBlue: '#4791db21',
  cancelledStatus: '#FF0000',
  successStatus: '#00A300',
  pendingStatus: '#FFA500',
};

export default colors;
